import React, { Component } from "react"
// import { OverlayTrigger, Tooltip} from 'react-bootstrap'
import { searchTableFilter } from "../Tree/Utils.js"

import SearchBar from '../Tree/components/SearchBar.jsx'
//import { EditableCell } from '../TableList/EditableCell'
import { ProductRow } from '../TableList/ProductRow'
import { one2seven} from '../../variables/ComboValues'

// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

const  microLegend = {
    "familywp_goal": "מטרה",
    "familywp_taskarray_description": "משימה",
    "familywp_taskarray_responsible": "אחראי",
    "familywp_taskarray_duedate": "ת. יעד",
    "familywp_shlish1": "חצי שנה",
    "familywp_shlish2": "שנה",
    "familywp_shlish3": "שנה וחצי",
    "familywp_shlish4": "שנתיים",
//    "familywp_shlish5": "שליש 5",
//    "familywp_shlish6": "שליש 6",
    "familywp_taskarray_comments": "הערות",
    "familywp_taskarray_needsolution": "מענה מהתכנית"
}
/*const tips = {
  "familywp_taskarray_comments": "התקדמות שליש תתחיל בשורה חדשה. בתחילתה הטקסט: ''שליש 1: והערות ככל שנדרש. כמובן לכל שליש המספר המתאים",
}
const tooltip = (text) => <Tooltip id="tooltip"><span style={{direction: 'rtl'}}>{text}</span></Tooltip>
*/
export class FamilyWPsub extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data === null ? [] : this.props.data}
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleAddEvent = this.handleAddEvent.bind(this)
      this.handleRowDel = this.handleRowDel.bind(this)
    }
    
    handleRowDel(product) {
      const {products} = this.state
      var index = products.indexOf(product)
      if (index === -1)
        return console.log("FamilyRights product not found", product)

      var array = [...products]
      array.splice(index, 1)
      this.setState({products:array})
    }
    
  
    handleAddEvent(evt) {
      evt.preventDefault()
      var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
      var product = {
        id: id,
         // "familywp_goal": "",
        "familywp_taskarray_description": "",
        "familywp_taskarray_responsible": "",
        "familywp_taskarray_duedate": "",
        "familywp_shlish1": "",
        "familywp_shlish2": "",
        "familywp_shlish3": "",
        "familywp_shlish4": "",
        //"familywp_shlish5": "",
        //"familywp_shlish6": "",
        "familywp_taskarray_comments": "חצי שנה: הערות כאן...." ,
        "familywp_taskarray_needsolution": ""
      }
      let newp = ""
      if (typeof this.state.products === "undefined"){
        newp = [product]
      } else {
        newp = Object.assign(this.state.products)
        newp.unshift(product)
      }
      this.setState({products:newp})
    }
  
    handleProductTable(evt) {
      evt.preventDefault()

      var item = {
        //id: evt.target.id,
        name: evt.target.name,
        value: evt.target.value,
        nid: evt.target.getAttribute('data-id')
    }
        // console.log("pRODUCT-EVT", item);

        var products = this.state.products.slice();
        // console.log("products-EVT", products);

        var newProducts = products.map(function(product) {
  
            for (var key in product) {
                if (key === item.name && product.id === item.nid) {
                    product[key] = item.value
                }
            }
            return product
        })
        this.setState({products:newProducts})
    }

    // merge subtable into main table
    onSaveTable(evt) {
      evt.preventDefault()
      this.props.onUpdate(this.state.products) // = {this.props.onUpdate}

     // const { save2DB, subTableId, familyPostId, inUpdate } = this.props
     //console.log("onSaveTable merge subtable into main table: products", this.state.products)
   
      //save2DB(familyPostId, this.state.products, subTableId, "table", inUpdate )
    }
    render() {
      const { tableTitle } = this.props
      let title = tableTitle === undefined ? "שם משפחה" : tableTitle
      // const { data } = this.props
      // console.log("Family general data", data)
      //console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable.bind(this)}
            onSaveTable={this.onSaveTable}
            headerColumns = {[ /*"familywp_goal",*/ "familywp_taskarray_description", "familywp_taskarray_responsible", 
                    "familywp_taskarray_duedate","familywp_shlish1","familywp_shlish2","familywp_shlish3","familywp_shlish4",
                    /*"familywp_shlish5","familywp_shlish6",*/ "familywp_taskarray_comments", "familywp_taskarray_needsolution"]}
                                
            tableTitle = {title} // "סיכומי מפגשים"
            onRowAdd={this.handleAddEvent} 
            onRowDel={this.handleRowDel} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, onRowDel, onRowAdd, headerColumns, products, onSaveTable } = this.props
      var filterText = this.state.filterText;
      var thStyle = { fontSize: '15px',color:'#333', fontWeight: 'bold'}
      var buttonStyle = {marginRight: '0'}
      var searchbarStyle = {margin: '5px 10px'}
      var product = (typeof products === "undefined")? [] : products.map(function(product) {
      //var product = products.map(function(product) {
          // check on all relevant data fields
          if (!searchTableFilter(product, filterText))
                return null;
                
        const cellData=[/*{
            type: "text",
            name: "familywp_goal",
            value: product.familywp_goal,
            id: product.id,
            style: {width: "160px"},
            edit: true
          },*/{
            type: "text",
            name: "familywp_taskarray_description",
            value: product.familywp_taskarray_description,
            id: product.id,
            style: {width: "150px"},
            edit: true
          },{
            type: "text",
            name: "familywp_taskarray_responsible",
            value: product.familywp_taskarray_responsible,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "text",
            name: "familywp_taskarray_duedate",
            value: product.familywp_taskarray_duedate,
            id: product.id,
            style: {width: "90px"},
            placeholder: 'dd/mm/yyyy',
            edit: true
          },{
            type: "select",
            options: one2seven,
            name: "familywp_shlish1",
            value: product.familywp_shlish1,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "select",
            options: one2seven,
            name: "familywp_shlish2",
            value: product.familywp_shlish2,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "select",
            options: one2seven,  // ["כלל לא-1", "2", "3", "4", "5", "6", "במידה רבה מאוד-7"],
            name: "familywp_shlish3",
            value: product.familywp_shlish3,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "select",
            options: one2seven,
            name: "familywp_shlish4",
            value: product.familywp_shlish4,
            id: product.id,
            style: {width: "80px"},
            edit: true
          }/*,{
            type: "select",
            options: one2seven,
            name: "familywp_shlish5",
            value: product.familywp_shlish5,
            id: product.id,
            style: {width: "30px"},
            edit: true
          },{
            type: "select",
            options: one2seven,
            name: "familywp_shlish6",
            value: product.familywp_shlish6,
            id: product.id,
            style: {width: "30px"},
            edit: true
          }*/,{
            type: "textarea",
            name: "familywp_taskarray_comments",
            value: product.familywp_taskarray_comments,
            id: product.id,
            style: {width: "150px"},
            edit: true
          },{
            type: "text",
            name: "familywp_taskarray_needsolution",
            value: product.familywp_taskarray_needsolution,
            id: product.id,
            style: {width: "80px"},
            edit: true
          }] 
              
        return (
          <ProductRow 
            onProductTableUpdate={onProductTableUpdate} 
            product={product} 
            onDelEvent={onRowDel.bind(this)} 
            key={product.id}
            cd={cellData}
            />)
      })

      return (
        <div className="yahav-modal">
            {/*<h2>{tableTitle}&nbsp;(סה"כ&nbsp;{typeof products === "undefined"? 0 : products.length})</h2>*/}
            <button style={buttonStyle} type="button" onClick={onRowAdd} className="btn btn-primary pull-right">הוספת משימה</button>
            <button style={buttonStyle} type="button"  className="btn btn-primary pull-left" onClick={onSaveTable}>עדכון</button>
            <SearchBar style={searchbarStyle} filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)} />
            <table className="table ">
                <thead>
                    <tr >
                    {headerColumns.map (col => { 
                      return(<th style={thStyle} key={col}>
                                {microLegend[col]?microLegend[col] : col}
                                {/* typeof tips[col] === undefined ? null :
                                      <OverlayTrigger placement="top" overlay={tooltip(tips[col])}>
                                          <span className="overLayQ">?</span>
                                      </OverlayTrigger>
                                */}
                            </th>) 
                  }) } 
                  
                    </tr>
                </thead>  
                <tbody>
                    {product}
                </tbody>
            </table>
        </div>
      )
    }
  }
 